/* @flow */
// Tags action types
export const SET_TAGS = 'tags/SET_TAGS';
export const ADD_TAG = 'tags/ADD_TAG';
export const UPDATE_TAG = 'tags/UPDATE_TAG';
export const DELETE_TAG = 'tags/DELETE_TAG';

// Tag picker action types
export const SHOW_TAG_PICKER = 'tags/SHOW_TAG_PICKER';
export const HIDE_TAG_PICKER = 'tags/HIDE_TAG_PICKER';
export const FORCE_TAG_PICKER_OPEN = 'tags/FORCE_TAG_PICKER_OPEN';

// Tag sorting action types
export const SET_TAG_SORT_INFO = 'tags/SET_TAG_SORT_INFO';